export const buildViewLoginPosterEvent = (inputProperties) => ({
    ...inputProperties,
    object: Promise.resolve(inputProperties.object).then((objectProperties) => ({
        ...objectProperties,
        type: 'LoginPoster',
    })),
});
//# sourceMappingURL=event-builder.js.map